export enum eventsTypes {
    EVENTS_TYPE_DATA = 'EVENTS_TYPE_DATA'
}